module.exports = __webpack_public_path__ + "static/media/portfolio4.188b36a4.png";